import { render } from "./left-menu.vue?vue&type=template&id=3b879a09&scoped=true&ts=true"
import script from "./left-menu.vue?vue&type=script&lang=ts"
export * from "./left-menu.vue?vue&type=script&lang=ts"

import "./left-menu.vue?vue&type=style&index=0&id=3b879a09&lang=scss"
import "./left-menu.vue?vue&type=style&index=1&id=3b879a09&lang=scss&scoped=true"
import "./left-menu.vue?vue&type=style&index=2&id=3b879a09&lang=scss"
/* custom blocks */
import block0 from "./i18n/messages.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3593438386%2Fsrc%2Fpadme-ui-aws%2Fapps%2Fmain%2Fsrc%2Flayouts%2Fmain%2Fcomponents%2Fleft-menu%2Fleft-menu.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b879a09"]])

export default __exports__